import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortfolioHealthCheckComponent } from './components/portfolio-health-check/portfolio-health-check.component';
import { RebalancingYourPortfolioComponent } from './components/portfolio-health-check/rebalancing-your-portfolio/rebalancing-your-portfolio.component';
import { NoGoalsComponent } from './components/portfolio-health-check/no-goals/no-goals.component';
import { PortfolioHealthCheckGuard } from './guards/portfolio-health-check.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [PortfolioHealthCheckGuard],
    children: [
      {
        path: 'no-goals',
        component: NoGoalsComponent,
        data: { pageId: 'no-goals' },
      },
      {
        path: 'rebalancing-your-portfolio',
        component: RebalancingYourPortfolioComponent,
        data: { pageId: 'rebalancing-your-portfolio' },
      },
      {
        path: '',
        component: PortfolioHealthCheckComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
